import { render, staticRenderFns } from "./RightsTable.vue?vue&type=template&id=16a0c96a&"
import script from "./RightsTable.vue?vue&type=script&lang=js&"
export * from "./RightsTable.vue?vue&type=script&lang=js&"
import style0 from "./RightsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports